import React, { useEffect, useState } from 'react';
import './PapperStyle.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Supprimer from './Supprimer';
import { FRONT_URL, BACKEND_URL_PORTAIL, BACKEND_URL_DOC, BACKEND_URL_LOG } from '../../../config/const';
import { Card, Container} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
function QuessRoleList() {
  const  idGroup  = localStorage.getItem('currentOrg');
 
  const { t } = useTranslation();
  const [groupByUser, setGroupByUser] = useState([]);
  const [hidden, setHidden] = useState(true);
  const [currentItemId, setCurrentItemId] = useState(0);
  const [teamName, setTeamName] = useState('');
  const [teamNameUpdated, setTeamNameUpdated] = useState('');
const [errorMessageRole, setErrorMessageRole] = useState('');
 document.title=  t('rolesManagement') +" | " +t('quessCompounding')
  useEffect(() => {
    getallTeamsByGroup(idGroup);
  }, []);

  const getallTeamsByGroup = (idGroup) => {
    axios.get(`${BACKEND_URL_LOG}getAllTeamsbyOrganisationId/${idGroup}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(response => setGroupByUser(response)).catch(error => console.error(error));
  };

 
const updateTeamGroup = (idTeam) => { 
  const data = { designation: teamNameUpdated, idTeam };

    Promise.all([
        axios.post(`${BACKEND_URL_LOG}updateTeamGroup`, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }),
        axios.post(`${BACKEND_URL_DOC}updateTeamGroup`, data, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
    ]).then(() => {
        setTimeout(() => {
          //getallTeamsByGroup(idGroup);
          setHidden(true);
          setTeamNameUpdated('');
          window.location.reload();
        }, 1500);
    }).catch(error => console.error("Error updating cleanroom:", error));
};

  const addTeamGroup = () => {
     if (!teamName.trim()) {
        setErrorMessageRole(t('errorMessageRole'));
        return;
    }

    setErrorMessageRole('');
    const data = { designation: teamName, idOrganisation: idGroup };
    Promise.all([
            axios.post(`${BACKEND_URL_LOG}addTeamToGroup`, data, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            }),
            axios.post(`${BACKEND_URL_DOC}addTeamToGroup`, data, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
        ]).then(() => {
            setTimeout(() => {
              //getallTeamsByGroup(idGroup);
              setTeamName('');
              window.location.reload();
            }, 1500);
        }).catch(error => console.error("Error adding cleanroom:", error));
  };

  return (
    <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card className="card-bordred custom-card">
    <Breadcrumbs title={t('QuessRoleManagement')} breadcrumbItem={t('listOfRoles')} />
      <div className="d-flex justify-content-center mb-3">
        <input 
          className="form-control w-25 me-2 inputRole" 
          placeholder={t('teamName')} 
          value={teamName} 
          onChange={(e) => setTeamName(e.target.value)} 
        />
        <button className="btn btn-primary btnAddRole" onClick={addTeamGroup}>{t('teamName')}</button>
      </div>
      {errorMessageRole && <p className="text-danger text-center">{errorMessageRole}</p>}
      <ul className="list-group">
      {groupByUser && groupByUser.length > 0 ? (
  groupByUser.map((item) => (
    <li key={item.id} className="list-group-item d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center">
        <div className="me-3">
          <i className="bi bi-person-circle fs-4 text-primary"></i>
        </div>
        <span className="fw-bold">{item.value}</span>
      </div>
      <div className="d-flex">
        {hidden === false && item.id === currentItemId ? (
          <>
            <input
              className="form-control me-2 inputRoleUpdate"
              value={teamNameUpdated}
              onChange={(e) => setTeamNameUpdated(e.target.value)}
            />
            <button className="btn btn-primary me-2 ContactBtn" onClick={() => updateTeamGroup(item.id)}>
              {t('SAVE')}
            </button>
            <button
              className="btn btn-primary ContactBtn"
              onClick={() => {
                setHidden(true);
                setTeamNameUpdated('');
              }}
            >
              {t('cancel')}
            </button>
          </>
        ) : (
          <>
            <button
              className="btn btn-primary me-2 ContactBtn"
              onClick={() => {
                setHidden(false);
                setCurrentItemId(item.id);
                setTeamNameUpdated(item.value);
              }}
            >
              {t('UPDATE')}
            </button>
            <Supprimer ItemId={item.id} name={item.value} />
          </>
        )}
      </div>
    </li>
  ))
) : (
  <p className="text-center text-muted">{t('noRoles')}</p>
)}

      </ul>
                    </Card>
                
   </Container>
               </div>
           </React.Fragment>
  );
}

export default QuessRoleList;
